import React, { useState } from 'react';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/auth.css';

export const Register: React.FC = () => {
  const navigate = useNavigate();
  const { register, user, isLoading } = useAuth();

  if (!isLoading && user) return <Navigate to="/" replace />;

  const [form, setForm] = useState({
    firstName: '', lastName: '', email: '', phone: '', password: '', confirm: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (form.password !== form.confirm) {
      setError('Passwords do not match.');
      return;
    }
    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(form.password)) {
      setError('Password must contain uppercase, lowercase, and a number.');
      return;
    }

    setLoading(true);
    try {
      await register({
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        phone: form.phone || undefined,
        password: form.password,
      });
      setSuccess('Account created successfully! Your account is pending admin approval. You\'ll receive an email once it\'s activated.');
      setForm({ firstName: '', lastName: '', email: '', phone: '', password: '', confirm: '' });
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ maxWidth: 460 }}>
        <div style={{ textAlign: "center", marginBottom: 8 }}>
          <img src="/logo.png" alt="E.H.C Logistics" style={{ height: 64, objectFit: "contain" }} />
        </div>
        <h2>Create Account</h2>

        {error && <div className="error-message">{error}</div>}
        {success && (
          <div style={{ background: '#dcfce7', color: '#166534', padding: '12px 14px', borderRadius: 6, marginBottom: 16, fontSize: 14 }}>
            {success}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label htmlFor="firstName">First Name *</label>
              <input id="firstName" name="firstName" value={form.firstName} onChange={handleChange} required placeholder="John" />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name *</label>
              <input id="lastName" name="lastName" value={form.lastName} onChange={handleChange} required placeholder="Doe" />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input type="email" id="email" name="email" value={form.email} onChange={handleChange} required placeholder="your@email.com" />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone <span style={{ color: '#94a3b8', fontSize: 12 }}>(optional)</span></label>
            <input type="tel" id="phone" name="phone" value={form.phone} onChange={handleChange} placeholder="+250784000000" />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password *</label>
            <input type="password" id="password" name="password" value={form.password} onChange={handleChange} required placeholder="Min 8 chars, upper + lower + number" />
          </div>

          <div className="form-group">
            <label htmlFor="confirm">Confirm Password *</label>
            <input type="password" id="confirm" name="confirm" value={form.confirm} onChange={handleChange} required placeholder="••••••••" />
          </div>

          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Already have an account? <Link to="/login">Sign in</Link></p>
          <p style={{ marginTop: 8 }}>
            <a href="/track" style={{ color: '#3b82f6', fontSize: 13 }}>
              📦 Track a shipment without logging in →
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
